<!-- Non-Shield User Footer Container -->
<div class="non-shield-user-footer-container">
  <div [ngClass]="app_footer_TAB_theme">
    <ion-tabs class="main_TABS" [ngClass]="{'main_TABS_black_theme': activateLeagueTheme2}" *ngIf="showTabs">

      <ion-tab-bar (click)="onCheckStatusClick()" slot="bottom" translucent="true" class="ion-no-border no_padding" [ngClass]="changeTabBg ? 'tab-bar-bg-change' : 'tab-bar-bg'" [class.is-hidden]="!showTabs" [ngClass]="{'footer_tab_theme': activateLeagueTheme}">
        <ng-container *ngIf="!replaceLeftTabsWtBtn">
          <!-- Default Tabs Dashboard & Action Mgmt -->
          <ion-tab-button aria-label="dashboard-menu"
          role="dashboard-menu" 
          Accessibility-ID="dashboard-menu"  name="dashboard-menu" tab="dashboard" class="footer_TAB_background" (click)="onHomeClick()">
            <img [src]="activateLeagueTheme ? 'assets/img/menu_icons/home_black_theme.svg': 'assets/img/menu_icons/home.svg' " [ngClass]="currentPage=='/dashboard' ? 'tabActive' : 'tabInactive'" class="action_count_icon">
          </ion-tab-button>

          <ion-tab-button aria-label="action-tab-menu"
          role="action-tab-menu" 
          Accessibility-ID="action-tab-menu"  name="action-tab-menu" id="action-tab" (click)="onActionMgmtClick()" class="comments footer_TAB_background">
            <span class="overDueActionCount" *ngIf="overdueActionCount >0 && connectionState">{{overdueActionCount}}</span>
            <img [src]="activateLeagueTheme ? 'assets/img/menu_icons/observation_icon_black_theme.svg' : 'assets/img/menu_icons/observation_icon.svg' " *ngIf="connectionState" [ngClass]="currentPage=='/action-management' || currentPage=='/action-management-non-hse' ? 'tabActive' : 'tabInactive'" class="action_count_icon">
            <img src="assets/img/menu_icons/observation_icon_disable.svg" *ngIf="!connectionState" class="action_count_icon">
          </ion-tab-button>
        </ng-container>
        <ng-container *ngIf="replaceLeftTabsWtBtn">
          <!-- When cancel/etc button needed at left tab -->
          <ion-tab-button aria-label="cancelbtn-menu"
          role="cancelbtn-menu" 
          Accessibility-ID="cancelbtn-menu" name="cancelbtn-menu"  [disabled]="vpcHazService?.disableLeftBtn"  (click)="onLeftButtonClick()" class="footer_TAB_background flex-grow-2">
            <ion-label id="cancelbtn" class="big-font" >{{replaceLeftTabsWtBtn.text}}</ion-label>
          </ion-tab-button>
        </ng-container>
        <ion-tab-button class="dummy-btn footer_TAB_background">
        </ion-tab-button>
        <ng-container *ngIf="!replaceRightTabsWtBtn">
          <!-- Default Tabs Housekeeping & Hamburger Menu -->
          <ion-tab-button aria-label="housekeeping-tab-menu"
          role="housekeeping-tab-menu" 
          Accessibility-ID="housekeeping-tab-menu"  name="housekeeping-tab-menu"  data-id="housekeeping-tab"  id="housekeeping-tab" class="footer_TAB_background" (click)="onPerformanceClick()">
            <img [src]="activateLeagueTheme ? 'assets/img/menu_icons/performance_black_theme.svg' : 'assets/img/menu_icons/performance_active.svg'" *ngIf="connectionState" [ngClass]="currentPage=='/performance' ? 'tabActive' : 'tabInactive'" class="hk_icon">
            <img src="assets/img/menu_icons/performance-disable.svg"  *ngIf="!connectionState" class="hk_icon">
          </ion-tab-button>
          <ion-tab-button aria-label="hamburger-tab-menu"
          role="hamburger-tab-menu" 
          Accessibility-ID="hamburger-tab-menu"  name="hamburger-tab-menu" data-id="hamburger-tab-menu" id="hamburger-tab" (click)="onHamburgerClick()" class="footer_TAB_background">
            <img aria-label="hamburger-tab-menu-img"
            role="hamburger-tab-menu-img" 
            Accessibility-ID="hamburger-tab-menu-img"  [src]="activateLeagueTheme ? 'assets/img/menu_icons/menu_icon_black_theme.svg' : 'assets/img/menu_icons/menu_icon.svg'"  class="action_count_icon tabInactive">
          </ion-tab-button>
        </ng-container>
        <ng-container *ngIf="replaceRightTabsWtBtn">
          <!-- When submit/etc button needed at right tab -->
          <ion-tab-button aria-label="submitbtn"
          role="submitbtn" 
          Accessibility-ID="submitbtn"  [disabled]="replaceRightTabsWtBtn.disabled()" (click)="onRightButtonClick()" class="footer_TAB_background flex-grow-2">
            <ion-label id="submitbtn" class="big-font" >{{replaceRightTabsWtBtn.text}}</ion-label>
          </ion-tab-button>
        </ng-container>
      </ion-tab-bar>
      
    </ion-tabs>

    <ion-fab #fab [class.is-hidden]="!showTabs || isKeyboardOpen" vertical="bottom" horizontal="center" translucent="true" [ngClass]="isControllerOptionOpen ? 'opencss' : 'closecss'" class="tabs-footer rapid_popup" [ngClass]="{'tabs-footer-black': activateLeagueTheme}" [ngStyle]="{'padding-block-end':bottomPadding}" [ngClass]="getFooterTABBtn()">
      <ion-fab-button id="insideBogTour" aria-label="insideBogTour"
      role="insideBogTour" 
      Accessibility-ID="insideBogTour"  (click)="onOpenIntermediateOptions()" *ngIf="bogTourButtonStatus=='INSIDE_BOG_TOUR'" class="non-field-btn">
        <img *ngIf="connectionState" src="assets/img/menu_icons/qr_icon.svg" class="">
        <ion-avatar class="scan_end_avator_1" *ngIf="!connectionState"> 
          <div class="scan_option">
            <img class="offline_scanner" src="assets/img/menu_icons/qr_icon.svg"></div>
          <div class="scan_end_divider"></div>
          <div class="end_option">{{'SHIELD.NETWORK_OFFLINE'|translate}}</div>
        </ion-avatar>
      </ion-fab-button>
      
      <ion-fab-button class="non-field-btn" aria-label="timer_bog_tour_started"
      role="timer_bog_tour_started" 
      Accessibility-ID="timer_bog_tour_started" id="timer_bog_tour_started" (click)="onTimerBogTourStartedClick()" *ngIf="bogTourButtonStatus=='TOUR_STARTED'   && currentPage!='/area-management-screen' && currentPage!='/zone-management-screen'  ">
        <div *ngIf="connectionState">{{tripTimer}} </div>
        <ion-avatar class="scan_end_avator" *ngIf="!connectionState"> 
          <div class="scan_option">{{tripTimer}}</div>
          <div class="scan_end_divider"></div>
          <div class="end_option">{{'SHIELD.NETWORK_OFFLINE'|translate}}</div>
        </ion-avatar>
      </ion-fab-button>
      
      <ion-fab-button class="non-field-btn" aria-label="more_under_area"
      role="more_under_area" 
      Accessibility-ID="more_under_area"  id="more_under_area" (click)="onMoreUnderAreaClick()" *ngIf="bogTourButtonStatus=='TOUR_STARTED' && (currentPage=='/area-management-screen' || currentPage=='/zone-management-screen')">
        <ion-avatar class="scan_end_avator">
        <div *ngIf="isControllerOptionOpen==false" class="scan_option">{{ "DASHBOARD.GRAPH.MORE" | translate }}</div>
        <div *ngIf="isControllerOptionOpen==true" class="scan_option">{{ "QR_SCANNER.CLOSE" | translate }}</div>
        <div class="scan_end_divider"></div>
        <div class="end_option">{{tripTimer}}</div>
        </ion-avatar>
      </ion-fab-button>
      
      <ion-fab-button class="non-field-btn" aria-label="bog_tour_not_started"
      role="bog_tour_not_started" 
      Accessibility-ID="bog_tour_not_started"   id="bog_tour_not_started" (click)="onBogTourNotStartedClick()" *ngIf="bogTourButtonStatus=='TOUR_NOT_STARTED'  && currentPage!='/area-management-screen' && currentPage!='/zone-management-screen'">
        {{getConversationtext('CONTROLLER_START')}}
      </ion-fab-button>

      <ion-fab-button class="non-field-btn" aria-label="bog_tour_not_started_area"
      role="bog_tour_not_started_area" 
      Accessibility-ID="bog_tour_not_started_area"  id="bog_tour_not_started_area" (click)="onBogTourNotStartedAreaClick()" *ngIf="bogTourButtonStatus=='TOUR_NOT_STARTED'  && (currentPage=='/area-management-screen' || currentPage=='/zone-management-screen')">
        <div *ngIf="isControllerOptionOpen==false">{{ "DASHBOARD.GRAPH.MORE" | translate }}</div>
        <div *ngIf="isControllerOptionOpen==true">{{ "QR_SCANNER.CLOSE" | translate }}</div>
      </ion-fab-button>

      <ion-fab-button class="non-field-btn" id="rapid_tour_not_started" [ngClass]="getFooterTABBtn()" (click)="onRapidTourNotStartedClick()" *ngIf="currentPage!='/take-rapid-tour' && bogTourButtonStatus=='RAPID_TOUR_NOT_STARTED' && currentPage!='/area-management-screen' && currentPage!='/zone-management-screen'  &&  currentPage!='/site-rating' && currentPage!='/area-rating'  ">
        <!-- {{'SHIELD_TEXT'|translate}} -->
        <img src="assets/img/checkin/tabs/shield_white_active.svg" class="">
      </ion-fab-button>
  
      <ion-fab-button class="non-field-btn" id="rapid_tour_not_started_area" (click)="onRapidTourNotStartedAreaClick()" *ngIf="bogTourButtonStatus=='RAPID_TOUR_NOT_STARTED' && (currentPage=='/area-management-screen' || currentPage=='/zone-management-screen')">
        {{ "DASHBOARD.GRAPH.MORE" | translate }}
      </ion-fab-button>

      <ion-fab-button class="non-field-btn" id="inside_rapid_tour" (click)="onRapidOption()" *ngIf="currentPage=='/take-rapid-tour'">
        <!-- <img src="assets/img/menu_icons/qr_icon.svg" class=""> -->
        {{tripTimer}}<br>
        {{ "QR_SCAN" | translate }}
      </ion-fab-button>

      <ion-fab-button class="non-field-btn" id="rapid_tour_started" (click)="onRapidTourStartedClick()" *ngIf="bogTourButtonStatus=='RAPID_TOUR_STARTED' && currentPage!='/take-rapid-tour' && !is_obs_screen && (currentPage!='/area-management-screen' && currentPage!='/zone-management-screen'  &&  currentPage!='/site-rating' && currentPage!='/area-rating' && !currentPage.includes('/observation-add-edit'))  ">
        {{tripTimer}}
      </ion-fab-button>

      <ion-fab-button class="non-field-btn" id="rapid_tour_started_area" (click)="onRapidTourStartedAreaClick()" *ngIf="bogTourButtonStatus=='RAPID_TOUR_STARTED' &&  (currentPage=='/area-management-screen' || currentPage=='/zone-management-screen')">
        <ion-avatar class="scan_end_avator"> 
        <div *ngIf="isControllerOptionOpen==false" class="scan_option"> {{ "DASHBOARD.GRAPH.MORE" | translate }}</div>
        <div *ngIf="isControllerOptionOpen==true" class="scan_option">{{ "QR_SCANNER.CLOSE" | translate }}</div>
        <div class="scan_end_divider"></div>
        <div class="end_option">{{tripTimer}}</div></ion-avatar>
      </ion-fab-button>

    </ion-fab>
  </div>
</div>
